import { render, staticRenderFns } from "./Terms1024.vue?vue&type=template&id=09ead228&scoped=true"
import script from "./Terms1024.vue?vue&type=script&lang=js"
export * from "./Terms1024.vue?vue&type=script&lang=js"
import style0 from "./Terms1024.vue?vue&type=style&index=0&id=09ead228&prod&lang=css&scoped=true"
import style1 from "./Terms1024.vue?vue&type=style&index=1&id=09ead228&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ead228",
  null
  
)

export default component.exports